import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import UtilService from '../../../../../../../helper/service';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    overflow: 'hidden',
    scrollbarWidth: 'none',
    position: 'relative'
  },
  graph: {
    opacity: 0.8,
    position: 'absolute'
  },
  square: {
    background: '#d6d8dB',
    marginRight: 2,
    borderTop: '4px solid #1DB859',
    fontSize: 33,
    fontFamily: 'Spartan-bold',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingBottom: 5,
    zIndex: -1,
    userSelect: 'none'
  }
}));

function CoreAnalysisBarGraph(props: any) {

  const classes = useStyles();
  const { graphData, marginTop, marginBottom } = props;
  const { analyseStart, cliped, currentSession, stimulus, settings } = useSelector((state: any) => state.analysis);
  const { session_type } = currentSession;
  const { graphZoom } = settings;
  const graphStart = cliped ? cliped.start_clip : (session_type === 'ASYNC' ? 0 : analyseStart);
  const videoLength = stimulus?.stimulus_video_length;

  return (
    <div
      className={classes.root}
      style={{
        height: marginTop ? 230 : 194,
        marginTop: marginTop ? marginTop : 60,
        marginBottom: marginBottom ? marginBottom : 70,
      }}
    >
      {
        graphData
          .filter((item: any) => item.epoch_start <= (session_type === 'ASYNC' ? stimulus?.stimulus_video_length : 10000000000))
          .map((item: any, index: number) => {

            const MODERATED_width = 120;
            const nextEpochStart = item[index + 1]?.epoch_start;
            const ASYNC_width = nextEpochStart ? nextEpochStart : (cliped ? cliped.end_clip : videoLength) - item.epoch_start;
            const width = (session_type === 'ASYNC' ? ASYNC_width : MODERATED_width) * 15 / Math.pow(graphZoom, 2);
            const left = (item.epoch_start - (graphStart)) * 15 / Math.pow(graphZoom, 2);

            return (
              <div
                key={index}
                className={classes.graph}
                style={{ width: ASYNC_width > 120 ? 120 * 15 / Math.pow(graphZoom, 2) : width, left }}
              >
                <div
                  className={classes.square}
                  style={{
                    height: item.immersion_index * 1.95,
                    borderTopColor: UtilService.refactorGraphColor(item.color_indicator),
                    color: UtilService.refactorGraphColor(item.color_indicator),
                    background: index % 2 === 0 ? '#CDCFD2' : '#E1E2E3',
                    fontSize: (120 * 15) / Math.pow(graphZoom, 2) < 50 ? 20 : 33,
                    paddingBottom: item.immersion_index < 20 ? item.immersion_index + (item.immersion_index < 10 ? 0 : 10) : 5
                  }}
                >
                  {item.immersion_index}
                </div>
              </div>)
          })}
    </div>
  );
}

export default CoreAnalysisBarGraph;